/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppCompaniesRouteImport } from './routes/app/companies'
import { Route as AppContactsRouteImport } from './routes/app/contacts'
import { Route as AppConversationsRouteRouteImport } from './routes/app/conversations/route'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as AppSettingsRouteRouteImport } from './routes/app/settings/route'
import { Route as ExploreIndexRouteImport } from './routes/explore/index'
import { Route as ExploreListingIdRouteImport } from './routes/explore/$listingId'
import { Route as ExploreCompareRouteImport } from './routes/explore/compare'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppAccountIndexRouteImport } from './routes/app/account/index'
import { Route as AppAccountApiKeysRouteImport } from './routes/app/account/api-keys'
import { Route as AppAgentsIndexRouteImport } from './routes/app/agents/index'
import { Route as AppAgentsSplatRouteImport } from './routes/app/agents/$'
import { Route as AppBoardIndexRouteImport } from './routes/app/board/index'
import { Route as AppBoardNewRouteImport } from './routes/app/board/new'
import { Route as AppCompaniesCompanyIdRouteImport } from './routes/app/companies_.$companyId'
import { Route as AppContactsContactIdRouteImport } from './routes/app/contacts_.$contactId'
import { Route as AppConversationsIndexRouteImport } from './routes/app/conversations/index'
import { Route as AppConversationsNewRouteImport } from './routes/app/conversations/new'
import { Route as AppConversationsArchiveRouteImport } from './routes/app/conversations_.archive'
import { Route as AppInboxUnresolvedRouteImport } from './routes/app/inbox/unresolved'
import { Route as AppLocationsIndexRouteImport } from './routes/app/locations/index'
import { Route as AppLocationsSplatRouteImport } from './routes/app/locations/$'
import { Route as AppOutboxIndexRouteImport } from './routes/app/outbox/index'
import { Route as AppOutboxOutboxIdRouteImport } from './routes/app/outbox/$outboxId'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppSettingsAgentsRouteRouteImport } from './routes/app/settings/agents/route'
import { Route as AppSettingsAiRouteImport } from './routes/app/settings/ai'
import { Route as AppSettingsAuditRouteImport } from './routes/app/settings/audit'
import { Route as AppSettingsAutomationRouteImport } from './routes/app/settings/automation'
import { Route as AppSettingsCommunicationRouteImport } from './routes/app/settings/communication'
import { Route as AppSettingsDataRouteImport } from './routes/app/settings/data'
import { Route as AppSettingsLlmRouteImport } from './routes/app/settings/llm'
import { Route as AppSettingsMailboxRouteImport } from './routes/app/settings/mailbox'
import { Route as AppSettingsMembersRouteImport } from './routes/app/settings/members'
import { Route as AppSettingsNotificationsRouteImport } from './routes/app/settings/notifications'
import { Route as AppSettingsPublicationRouteImport } from './routes/app/settings/publication'
import { Route as AppBoardLocationIdIndexRouteImport } from './routes/app/board/$locationId/index'
import { Route as AppBoardLocationIdEditRouteImport } from './routes/app/board/$locationId_.edit'
import { Route as AppConversationsConversationIdIndexRouteImport } from './routes/app/conversations/$conversationId/index'
import { Route as AppSettingsAgentsIndexRouteImport } from './routes/app/settings/agents/index'
import { Route as AppSettingsAgentsJobsRouteImport } from './routes/app/settings/agents/jobs'
import { Route as AppSettingsAgentsRunsIndexRouteImport } from './routes/app/settings/agents/runs/index'
import { Route as AppSettingsAgentsRunsRunIdRouteImport } from './routes/app/settings/agents/runs/$runId'
import { Route as AppSettingsAgentsSessionsIndexRouteImport } from './routes/app/settings/agents/sessions/index'
import { Route as AppSettingsAgentsSessionsSessionIdRouteImport } from './routes/app/settings/agents/sessions/$sessionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompaniesRoute = AppCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppConversationsRouteRoute = AppConversationsRouteRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const ExploreIndexRoute = ExploreIndexRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreListingIdRoute = ExploreListingIdRouteImport.update({
  id: '/explore/$listingId',
  path: '/explore/$listingId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreCompareRoute = ExploreCompareRouteImport.update({
  id: '/explore/compare',
  path: '/explore/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountApiKeysRoute = AppAccountApiKeysRouteImport.update({
  id: '/account/api-keys',
  path: '/account/api-keys',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAgentsSplatRoute = AppAgentsSplatRouteImport.update({
  id: '/agents/$',
  path: '/agents/$',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBoardIndexRoute = AppBoardIndexRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBoardNewRoute = AppBoardNewRouteImport.update({
  id: '/board/new',
  path: '/board/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompaniesCompanyIdRoute = AppCompaniesCompanyIdRouteImport.update({
  id: '/companies_/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/contacts_/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppConversationsIndexRoute = AppConversationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppConversationsRouteRoute,
} as any)
const AppConversationsNewRoute = AppConversationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppConversationsRouteRoute,
} as any)
const AppConversationsArchiveRoute = AppConversationsArchiveRouteImport.update({
  id: '/conversations_/archive',
  path: '/conversations/archive',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInboxUnresolvedRoute = AppInboxUnresolvedRouteImport.update({
  id: '/inbox/unresolved',
  path: '/inbox/unresolved',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLocationsIndexRoute = AppLocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLocationsSplatRoute = AppLocationsSplatRouteImport.update({
  id: '/locations/$',
  path: '/locations/$',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOutboxIndexRoute = AppOutboxIndexRouteImport.update({
  id: '/outbox/',
  path: '/outbox/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOutboxOutboxIdRoute = AppOutboxOutboxIdRouteImport.update({
  id: '/outbox/$outboxId',
  path: '/outbox/$outboxId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAgentsRouteRoute = AppSettingsAgentsRouteRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutomationRoute = AppSettingsAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCommunicationRoute =
  AppSettingsCommunicationRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsDataRoute = AppSettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLlmRoute = AppSettingsLlmRouteImport.update({
  id: '/llm',
  path: '/llm',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMailboxRoute = AppSettingsMailboxRouteImport.update({
  id: '/mailbox',
  path: '/mailbox',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPublicationRoute = AppSettingsPublicationRouteImport.update({
  id: '/publication',
  path: '/publication',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppBoardLocationIdIndexRoute = AppBoardLocationIdIndexRouteImport.update({
  id: '/board/$locationId/',
  path: '/board/$locationId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBoardLocationIdEditRoute = AppBoardLocationIdEditRouteImport.update({
  id: '/board/$locationId_/edit',
  path: '/board/$locationId/edit',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppConversationsConversationIdIndexRoute =
  AppConversationsConversationIdIndexRouteImport.update({
    id: '/$conversationId/',
    path: '/$conversationId/',
    getParentRoute: () => AppConversationsRouteRoute,
  } as any)
const AppSettingsAgentsIndexRoute = AppSettingsAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsAgentsRouteRoute,
} as any)
const AppSettingsAgentsJobsRoute = AppSettingsAgentsJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppSettingsAgentsRouteRoute,
} as any)
const AppSettingsAgentsRunsIndexRoute =
  AppSettingsAgentsRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AppSettingsAgentsRouteRoute,
  } as any)
const AppSettingsAgentsRunsRunIdRoute =
  AppSettingsAgentsRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AppSettingsAgentsRouteRoute,
  } as any)
const AppSettingsAgentsSessionsIndexRoute =
  AppSettingsAgentsSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AppSettingsAgentsRouteRoute,
  } as any)
const AppSettingsAgentsSessionsSessionIdRoute =
  AppSettingsAgentsSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => AppSettingsAgentsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/app/conversations': typeof AppConversationsRouteRouteWithChildren
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/app/companies': typeof AppCompaniesRoute
  '/app/contacts': typeof AppContactsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/explore/$listingId': typeof ExploreListingIdRoute
  '/explore/compare': typeof ExploreCompareRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app/': typeof AppIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/app/settings/agents': typeof AppSettingsAgentsRouteRouteWithChildren
  '/app/account/api-keys': typeof AppAccountApiKeysRoute
  '/app/agents/$': typeof AppAgentsSplatRoute
  '/app/board/new': typeof AppBoardNewRoute
  '/app/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/app/conversations/new': typeof AppConversationsNewRoute
  '/app/conversations/archive': typeof AppConversationsArchiveRoute
  '/app/inbox/unresolved': typeof AppInboxUnresolvedRoute
  '/app/locations/$': typeof AppLocationsSplatRoute
  '/app/outbox/$outboxId': typeof AppOutboxOutboxIdRoute
  '/app/settings/ai': typeof AppSettingsAiRoute
  '/app/settings/audit': typeof AppSettingsAuditRoute
  '/app/settings/automation': typeof AppSettingsAutomationRoute
  '/app/settings/communication': typeof AppSettingsCommunicationRoute
  '/app/settings/data': typeof AppSettingsDataRoute
  '/app/settings/llm': typeof AppSettingsLlmRoute
  '/app/settings/mailbox': typeof AppSettingsMailboxRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/settings/publication': typeof AppSettingsPublicationRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/agents/': typeof AppAgentsIndexRoute
  '/app/board/': typeof AppBoardIndexRoute
  '/app/conversations/': typeof AppConversationsIndexRoute
  '/app/locations/': typeof AppLocationsIndexRoute
  '/app/outbox/': typeof AppOutboxIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/board/$locationId/edit': typeof AppBoardLocationIdEditRoute
  '/app/settings/agents/jobs': typeof AppSettingsAgentsJobsRoute
  '/app/board/$locationId/': typeof AppBoardLocationIdIndexRoute
  '/app/conversations/$conversationId/': typeof AppConversationsConversationIdIndexRoute
  '/app/settings/agents/': typeof AppSettingsAgentsIndexRoute
  '/app/settings/agents/runs/$runId': typeof AppSettingsAgentsRunsRunIdRoute
  '/app/settings/agents/sessions/$sessionId': typeof AppSettingsAgentsSessionsSessionIdRoute
  '/app/settings/agents/runs/': typeof AppSettingsAgentsRunsIndexRoute
  '/app/settings/agents/sessions/': typeof AppSettingsAgentsSessionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/app/companies': typeof AppCompaniesRoute
  '/app/contacts': typeof AppContactsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/explore/$listingId': typeof ExploreListingIdRoute
  '/explore/compare': typeof ExploreCompareRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app': typeof AppIndexRoute
  '/explore': typeof ExploreIndexRoute
  '/app/account/api-keys': typeof AppAccountApiKeysRoute
  '/app/agents/$': typeof AppAgentsSplatRoute
  '/app/board/new': typeof AppBoardNewRoute
  '/app/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/app/conversations/new': typeof AppConversationsNewRoute
  '/app/conversations/archive': typeof AppConversationsArchiveRoute
  '/app/inbox/unresolved': typeof AppInboxUnresolvedRoute
  '/app/locations/$': typeof AppLocationsSplatRoute
  '/app/outbox/$outboxId': typeof AppOutboxOutboxIdRoute
  '/app/settings/ai': typeof AppSettingsAiRoute
  '/app/settings/audit': typeof AppSettingsAuditRoute
  '/app/settings/automation': typeof AppSettingsAutomationRoute
  '/app/settings/communication': typeof AppSettingsCommunicationRoute
  '/app/settings/data': typeof AppSettingsDataRoute
  '/app/settings/llm': typeof AppSettingsLlmRoute
  '/app/settings/mailbox': typeof AppSettingsMailboxRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/settings/publication': typeof AppSettingsPublicationRoute
  '/app/account': typeof AppAccountIndexRoute
  '/app/agents': typeof AppAgentsIndexRoute
  '/app/board': typeof AppBoardIndexRoute
  '/app/conversations': typeof AppConversationsIndexRoute
  '/app/locations': typeof AppLocationsIndexRoute
  '/app/outbox': typeof AppOutboxIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/board/$locationId/edit': typeof AppBoardLocationIdEditRoute
  '/app/settings/agents/jobs': typeof AppSettingsAgentsJobsRoute
  '/app/board/$locationId': typeof AppBoardLocationIdIndexRoute
  '/app/conversations/$conversationId': typeof AppConversationsConversationIdIndexRoute
  '/app/settings/agents': typeof AppSettingsAgentsIndexRoute
  '/app/settings/agents/runs/$runId': typeof AppSettingsAgentsRunsRunIdRoute
  '/app/settings/agents/sessions/$sessionId': typeof AppSettingsAgentsSessionsSessionIdRoute
  '/app/settings/agents/runs': typeof AppSettingsAgentsRunsIndexRoute
  '/app/settings/agents/sessions': typeof AppSettingsAgentsSessionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/app/conversations': typeof AppConversationsRouteRouteWithChildren
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/app/companies': typeof AppCompaniesRoute
  '/app/contacts': typeof AppContactsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/explore/$listingId': typeof ExploreListingIdRoute
  '/explore/compare': typeof ExploreCompareRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app/': typeof AppIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/app/settings/agents': typeof AppSettingsAgentsRouteRouteWithChildren
  '/app/account/api-keys': typeof AppAccountApiKeysRoute
  '/app/agents/$': typeof AppAgentsSplatRoute
  '/app/board/new': typeof AppBoardNewRoute
  '/app/companies_/$companyId': typeof AppCompaniesCompanyIdRoute
  '/app/contacts_/$contactId': typeof AppContactsContactIdRoute
  '/app/conversations/new': typeof AppConversationsNewRoute
  '/app/conversations_/archive': typeof AppConversationsArchiveRoute
  '/app/inbox/unresolved': typeof AppInboxUnresolvedRoute
  '/app/locations/$': typeof AppLocationsSplatRoute
  '/app/outbox/$outboxId': typeof AppOutboxOutboxIdRoute
  '/app/settings/ai': typeof AppSettingsAiRoute
  '/app/settings/audit': typeof AppSettingsAuditRoute
  '/app/settings/automation': typeof AppSettingsAutomationRoute
  '/app/settings/communication': typeof AppSettingsCommunicationRoute
  '/app/settings/data': typeof AppSettingsDataRoute
  '/app/settings/llm': typeof AppSettingsLlmRoute
  '/app/settings/mailbox': typeof AppSettingsMailboxRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/settings/publication': typeof AppSettingsPublicationRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/agents/': typeof AppAgentsIndexRoute
  '/app/board/': typeof AppBoardIndexRoute
  '/app/conversations/': typeof AppConversationsIndexRoute
  '/app/locations/': typeof AppLocationsIndexRoute
  '/app/outbox/': typeof AppOutboxIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/board/$locationId_/edit': typeof AppBoardLocationIdEditRoute
  '/app/settings/agents/jobs': typeof AppSettingsAgentsJobsRoute
  '/app/board/$locationId/': typeof AppBoardLocationIdIndexRoute
  '/app/conversations/$conversationId/': typeof AppConversationsConversationIdIndexRoute
  '/app/settings/agents/': typeof AppSettingsAgentsIndexRoute
  '/app/settings/agents/runs/$runId': typeof AppSettingsAgentsRunsRunIdRoute
  '/app/settings/agents/sessions/$sessionId': typeof AppSettingsAgentsSessionsSessionIdRoute
  '/app/settings/agents/runs/': typeof AppSettingsAgentsRunsIndexRoute
  '/app/settings/agents/sessions/': typeof AppSettingsAgentsSessionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/app/conversations'
    | '/app/settings'
    | '/app/companies'
    | '/app/contacts'
    | '/app/notifications'
    | '/explore/$listingId'
    | '/explore/compare'
    | '/invite/$token'
    | '/app/'
    | '/explore/'
    | '/app/settings/agents'
    | '/app/account/api-keys'
    | '/app/agents/$'
    | '/app/board/new'
    | '/app/companies/$companyId'
    | '/app/contacts/$contactId'
    | '/app/conversations/new'
    | '/app/conversations/archive'
    | '/app/inbox/unresolved'
    | '/app/locations/$'
    | '/app/outbox/$outboxId'
    | '/app/settings/ai'
    | '/app/settings/audit'
    | '/app/settings/automation'
    | '/app/settings/communication'
    | '/app/settings/data'
    | '/app/settings/llm'
    | '/app/settings/mailbox'
    | '/app/settings/members'
    | '/app/settings/notifications'
    | '/app/settings/publication'
    | '/app/account/'
    | '/app/agents/'
    | '/app/board/'
    | '/app/conversations/'
    | '/app/locations/'
    | '/app/outbox/'
    | '/app/settings/'
    | '/app/board/$locationId/edit'
    | '/app/settings/agents/jobs'
    | '/app/board/$locationId/'
    | '/app/conversations/$conversationId/'
    | '/app/settings/agents/'
    | '/app/settings/agents/runs/$runId'
    | '/app/settings/agents/sessions/$sessionId'
    | '/app/settings/agents/runs/'
    | '/app/settings/agents/sessions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/app/companies'
    | '/app/contacts'
    | '/app/notifications'
    | '/explore/$listingId'
    | '/explore/compare'
    | '/invite/$token'
    | '/app'
    | '/explore'
    | '/app/account/api-keys'
    | '/app/agents/$'
    | '/app/board/new'
    | '/app/companies/$companyId'
    | '/app/contacts/$contactId'
    | '/app/conversations/new'
    | '/app/conversations/archive'
    | '/app/inbox/unresolved'
    | '/app/locations/$'
    | '/app/outbox/$outboxId'
    | '/app/settings/ai'
    | '/app/settings/audit'
    | '/app/settings/automation'
    | '/app/settings/communication'
    | '/app/settings/data'
    | '/app/settings/llm'
    | '/app/settings/mailbox'
    | '/app/settings/members'
    | '/app/settings/notifications'
    | '/app/settings/publication'
    | '/app/account'
    | '/app/agents'
    | '/app/board'
    | '/app/conversations'
    | '/app/locations'
    | '/app/outbox'
    | '/app/settings'
    | '/app/board/$locationId/edit'
    | '/app/settings/agents/jobs'
    | '/app/board/$locationId'
    | '/app/conversations/$conversationId'
    | '/app/settings/agents'
    | '/app/settings/agents/runs/$runId'
    | '/app/settings/agents/sessions/$sessionId'
    | '/app/settings/agents/runs'
    | '/app/settings/agents/sessions'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/app/conversations'
    | '/app/settings'
    | '/app/companies'
    | '/app/contacts'
    | '/app/notifications'
    | '/explore/$listingId'
    | '/explore/compare'
    | '/invite/$token'
    | '/app/'
    | '/explore/'
    | '/app/settings/agents'
    | '/app/account/api-keys'
    | '/app/agents/$'
    | '/app/board/new'
    | '/app/companies_/$companyId'
    | '/app/contacts_/$contactId'
    | '/app/conversations/new'
    | '/app/conversations_/archive'
    | '/app/inbox/unresolved'
    | '/app/locations/$'
    | '/app/outbox/$outboxId'
    | '/app/settings/ai'
    | '/app/settings/audit'
    | '/app/settings/automation'
    | '/app/settings/communication'
    | '/app/settings/data'
    | '/app/settings/llm'
    | '/app/settings/mailbox'
    | '/app/settings/members'
    | '/app/settings/notifications'
    | '/app/settings/publication'
    | '/app/account/'
    | '/app/agents/'
    | '/app/board/'
    | '/app/conversations/'
    | '/app/locations/'
    | '/app/outbox/'
    | '/app/settings/'
    | '/app/board/$locationId_/edit'
    | '/app/settings/agents/jobs'
    | '/app/board/$locationId/'
    | '/app/conversations/$conversationId/'
    | '/app/settings/agents/'
    | '/app/settings/agents/runs/$runId'
    | '/app/settings/agents/sessions/$sessionId'
    | '/app/settings/agents/runs/'
    | '/app/settings/agents/sessions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  ExploreListingIdRoute: typeof ExploreListingIdRoute
  ExploreCompareRoute: typeof ExploreCompareRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ExploreIndexRoute: typeof ExploreIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/companies': {
      id: '/app/companies'
      path: '/companies'
      fullPath: '/app/companies'
      preLoaderRoute: typeof AppCompaniesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contacts': {
      id: '/app/contacts'
      path: '/contacts'
      fullPath: '/app/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/conversations': {
      id: '/app/conversations'
      path: '/conversations'
      fullPath: '/app/conversations'
      preLoaderRoute: typeof AppConversationsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore/'
      preLoaderRoute: typeof ExploreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/$listingId': {
      id: '/explore/$listingId'
      path: '/explore/$listingId'
      fullPath: '/explore/$listingId'
      preLoaderRoute: typeof ExploreListingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/compare': {
      id: '/explore/compare'
      path: '/explore/compare'
      fullPath: '/explore/compare'
      preLoaderRoute: typeof ExploreCompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/account/': {
      id: '/app/account/'
      path: '/account'
      fullPath: '/app/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/account/api-keys': {
      id: '/app/account/api-keys'
      path: '/account/api-keys'
      fullPath: '/app/account/api-keys'
      preLoaderRoute: typeof AppAccountApiKeysRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/agents/': {
      id: '/app/agents/'
      path: '/agents'
      fullPath: '/app/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/agents/$': {
      id: '/app/agents/$'
      path: '/agents/$'
      fullPath: '/app/agents/$'
      preLoaderRoute: typeof AppAgentsSplatRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/board/': {
      id: '/app/board/'
      path: '/board'
      fullPath: '/app/board/'
      preLoaderRoute: typeof AppBoardIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/board/new': {
      id: '/app/board/new'
      path: '/board/new'
      fullPath: '/app/board/new'
      preLoaderRoute: typeof AppBoardNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/companies_/$companyId': {
      id: '/app/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/app/companies/$companyId'
      preLoaderRoute: typeof AppCompaniesCompanyIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contacts_/$contactId': {
      id: '/app/contacts_/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/app/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/conversations/': {
      id: '/app/conversations/'
      path: '/'
      fullPath: '/app/conversations/'
      preLoaderRoute: typeof AppConversationsIndexRouteImport
      parentRoute: typeof AppConversationsRouteRoute
    }
    '/app/conversations/new': {
      id: '/app/conversations/new'
      path: '/new'
      fullPath: '/app/conversations/new'
      preLoaderRoute: typeof AppConversationsNewRouteImport
      parentRoute: typeof AppConversationsRouteRoute
    }
    '/app/conversations_/archive': {
      id: '/app/conversations_/archive'
      path: '/conversations/archive'
      fullPath: '/app/conversations/archive'
      preLoaderRoute: typeof AppConversationsArchiveRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/inbox/unresolved': {
      id: '/app/inbox/unresolved'
      path: '/inbox/unresolved'
      fullPath: '/app/inbox/unresolved'
      preLoaderRoute: typeof AppInboxUnresolvedRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/locations/': {
      id: '/app/locations/'
      path: '/locations'
      fullPath: '/app/locations/'
      preLoaderRoute: typeof AppLocationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/locations/$': {
      id: '/app/locations/$'
      path: '/locations/$'
      fullPath: '/app/locations/$'
      preLoaderRoute: typeof AppLocationsSplatRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/outbox/': {
      id: '/app/outbox/'
      path: '/outbox'
      fullPath: '/app/outbox/'
      preLoaderRoute: typeof AppOutboxIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/outbox/$outboxId': {
      id: '/app/outbox/$outboxId'
      path: '/outbox/$outboxId'
      fullPath: '/app/outbox/$outboxId'
      preLoaderRoute: typeof AppOutboxOutboxIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/agents': {
      id: '/app/settings/agents'
      path: '/agents'
      fullPath: '/app/settings/agents'
      preLoaderRoute: typeof AppSettingsAgentsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/ai': {
      id: '/app/settings/ai'
      path: '/ai'
      fullPath: '/app/settings/ai'
      preLoaderRoute: typeof AppSettingsAiRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/audit': {
      id: '/app/settings/audit'
      path: '/audit'
      fullPath: '/app/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/automation': {
      id: '/app/settings/automation'
      path: '/automation'
      fullPath: '/app/settings/automation'
      preLoaderRoute: typeof AppSettingsAutomationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/communication': {
      id: '/app/settings/communication'
      path: '/communication'
      fullPath: '/app/settings/communication'
      preLoaderRoute: typeof AppSettingsCommunicationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/data': {
      id: '/app/settings/data'
      path: '/data'
      fullPath: '/app/settings/data'
      preLoaderRoute: typeof AppSettingsDataRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/llm': {
      id: '/app/settings/llm'
      path: '/llm'
      fullPath: '/app/settings/llm'
      preLoaderRoute: typeof AppSettingsLlmRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/mailbox': {
      id: '/app/settings/mailbox'
      path: '/mailbox'
      fullPath: '/app/settings/mailbox'
      preLoaderRoute: typeof AppSettingsMailboxRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/members': {
      id: '/app/settings/members'
      path: '/members'
      fullPath: '/app/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/notifications': {
      id: '/app/settings/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/publication': {
      id: '/app/settings/publication'
      path: '/publication'
      fullPath: '/app/settings/publication'
      preLoaderRoute: typeof AppSettingsPublicationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/board/$locationId/': {
      id: '/app/board/$locationId/'
      path: '/board/$locationId'
      fullPath: '/app/board/$locationId/'
      preLoaderRoute: typeof AppBoardLocationIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/board/$locationId_/edit': {
      id: '/app/board/$locationId_/edit'
      path: '/board/$locationId/edit'
      fullPath: '/app/board/$locationId/edit'
      preLoaderRoute: typeof AppBoardLocationIdEditRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/conversations/$conversationId/': {
      id: '/app/conversations/$conversationId/'
      path: '/$conversationId'
      fullPath: '/app/conversations/$conversationId/'
      preLoaderRoute: typeof AppConversationsConversationIdIndexRouteImport
      parentRoute: typeof AppConversationsRouteRoute
    }
    '/app/settings/agents/': {
      id: '/app/settings/agents/'
      path: '/'
      fullPath: '/app/settings/agents/'
      preLoaderRoute: typeof AppSettingsAgentsIndexRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
    '/app/settings/agents/jobs': {
      id: '/app/settings/agents/jobs'
      path: '/jobs'
      fullPath: '/app/settings/agents/jobs'
      preLoaderRoute: typeof AppSettingsAgentsJobsRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
    '/app/settings/agents/runs/': {
      id: '/app/settings/agents/runs/'
      path: '/runs'
      fullPath: '/app/settings/agents/runs/'
      preLoaderRoute: typeof AppSettingsAgentsRunsIndexRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
    '/app/settings/agents/runs/$runId': {
      id: '/app/settings/agents/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/app/settings/agents/runs/$runId'
      preLoaderRoute: typeof AppSettingsAgentsRunsRunIdRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
    '/app/settings/agents/sessions/': {
      id: '/app/settings/agents/sessions/'
      path: '/sessions'
      fullPath: '/app/settings/agents/sessions/'
      preLoaderRoute: typeof AppSettingsAgentsSessionsIndexRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
    '/app/settings/agents/sessions/$sessionId': {
      id: '/app/settings/agents/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/app/settings/agents/sessions/$sessionId'
      preLoaderRoute: typeof AppSettingsAgentsSessionsSessionIdRouteImport
      parentRoute: typeof AppSettingsAgentsRouteRoute
    }
  }
}

interface AppConversationsRouteRouteChildren {
  AppConversationsNewRoute: typeof AppConversationsNewRoute
  AppConversationsIndexRoute: typeof AppConversationsIndexRoute
  AppConversationsConversationIdIndexRoute: typeof AppConversationsConversationIdIndexRoute
}

const AppConversationsRouteRouteChildren: AppConversationsRouteRouteChildren = {
  AppConversationsNewRoute: AppConversationsNewRoute,
  AppConversationsIndexRoute: AppConversationsIndexRoute,
  AppConversationsConversationIdIndexRoute:
    AppConversationsConversationIdIndexRoute,
}

const AppConversationsRouteRouteWithChildren =
  AppConversationsRouteRoute._addFileChildren(
    AppConversationsRouteRouteChildren,
  )

interface AppSettingsAgentsRouteRouteChildren {
  AppSettingsAgentsJobsRoute: typeof AppSettingsAgentsJobsRoute
  AppSettingsAgentsIndexRoute: typeof AppSettingsAgentsIndexRoute
  AppSettingsAgentsRunsRunIdRoute: typeof AppSettingsAgentsRunsRunIdRoute
  AppSettingsAgentsSessionsSessionIdRoute: typeof AppSettingsAgentsSessionsSessionIdRoute
  AppSettingsAgentsRunsIndexRoute: typeof AppSettingsAgentsRunsIndexRoute
  AppSettingsAgentsSessionsIndexRoute: typeof AppSettingsAgentsSessionsIndexRoute
}

const AppSettingsAgentsRouteRouteChildren: AppSettingsAgentsRouteRouteChildren =
  {
    AppSettingsAgentsJobsRoute: AppSettingsAgentsJobsRoute,
    AppSettingsAgentsIndexRoute: AppSettingsAgentsIndexRoute,
    AppSettingsAgentsRunsRunIdRoute: AppSettingsAgentsRunsRunIdRoute,
    AppSettingsAgentsSessionsSessionIdRoute:
      AppSettingsAgentsSessionsSessionIdRoute,
    AppSettingsAgentsRunsIndexRoute: AppSettingsAgentsRunsIndexRoute,
    AppSettingsAgentsSessionsIndexRoute: AppSettingsAgentsSessionsIndexRoute,
  }

const AppSettingsAgentsRouteRouteWithChildren =
  AppSettingsAgentsRouteRoute._addFileChildren(
    AppSettingsAgentsRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsAgentsRouteRoute: typeof AppSettingsAgentsRouteRouteWithChildren
  AppSettingsAiRoute: typeof AppSettingsAiRoute
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsAutomationRoute: typeof AppSettingsAutomationRoute
  AppSettingsCommunicationRoute: typeof AppSettingsCommunicationRoute
  AppSettingsDataRoute: typeof AppSettingsDataRoute
  AppSettingsLlmRoute: typeof AppSettingsLlmRoute
  AppSettingsMailboxRoute: typeof AppSettingsMailboxRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPublicationRoute: typeof AppSettingsPublicationRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAgentsRouteRoute: AppSettingsAgentsRouteRouteWithChildren,
  AppSettingsAiRoute: AppSettingsAiRoute,
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsAutomationRoute: AppSettingsAutomationRoute,
  AppSettingsCommunicationRoute: AppSettingsCommunicationRoute,
  AppSettingsDataRoute: AppSettingsDataRoute,
  AppSettingsLlmRoute: AppSettingsLlmRoute,
  AppSettingsMailboxRoute: AppSettingsMailboxRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPublicationRoute: AppSettingsPublicationRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppConversationsRouteRoute: typeof AppConversationsRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppCompaniesRoute: typeof AppCompaniesRoute
  AppContactsRoute: typeof AppContactsRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountApiKeysRoute: typeof AppAccountApiKeysRoute
  AppAgentsSplatRoute: typeof AppAgentsSplatRoute
  AppBoardNewRoute: typeof AppBoardNewRoute
  AppCompaniesCompanyIdRoute: typeof AppCompaniesCompanyIdRoute
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppConversationsArchiveRoute: typeof AppConversationsArchiveRoute
  AppInboxUnresolvedRoute: typeof AppInboxUnresolvedRoute
  AppLocationsSplatRoute: typeof AppLocationsSplatRoute
  AppOutboxOutboxIdRoute: typeof AppOutboxOutboxIdRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppBoardIndexRoute: typeof AppBoardIndexRoute
  AppLocationsIndexRoute: typeof AppLocationsIndexRoute
  AppOutboxIndexRoute: typeof AppOutboxIndexRoute
  AppBoardLocationIdEditRoute: typeof AppBoardLocationIdEditRoute
  AppBoardLocationIdIndexRoute: typeof AppBoardLocationIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppConversationsRouteRoute: AppConversationsRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppCompaniesRoute: AppCompaniesRoute,
  AppContactsRoute: AppContactsRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountApiKeysRoute: AppAccountApiKeysRoute,
  AppAgentsSplatRoute: AppAgentsSplatRoute,
  AppBoardNewRoute: AppBoardNewRoute,
  AppCompaniesCompanyIdRoute: AppCompaniesCompanyIdRoute,
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppConversationsArchiveRoute: AppConversationsArchiveRoute,
  AppInboxUnresolvedRoute: AppInboxUnresolvedRoute,
  AppLocationsSplatRoute: AppLocationsSplatRoute,
  AppOutboxOutboxIdRoute: AppOutboxOutboxIdRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppBoardIndexRoute: AppBoardIndexRoute,
  AppLocationsIndexRoute: AppLocationsIndexRoute,
  AppOutboxIndexRoute: AppOutboxIndexRoute,
  AppBoardLocationIdEditRoute: AppBoardLocationIdEditRoute,
  AppBoardLocationIdIndexRoute: AppBoardLocationIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  ExploreListingIdRoute: ExploreListingIdRoute,
  ExploreCompareRoute: ExploreCompareRoute,
  InviteTokenRoute: InviteTokenRoute,
  ExploreIndexRoute: ExploreIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
